import React from 'react';
import { Box, styled } from '@mui/material';

const StyledScrollableContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: '64px', // Height for 2 rows of chips
  overflowY: 'auto',
  padding: '4px 0',
  gap: '4px',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
});

interface ScrollableChipsContainerProps {
  children: React.ReactNode;
  maxHeight?: string;
}

export const ScrollableChipsContainer: React.FC<ScrollableChipsContainerProps> = ({
  children,
  maxHeight = '64px',
}) => {
  return <StyledScrollableContainer sx={{ maxHeight }}>{children}</StyledScrollableContainer>;
};
